import { InjectionToken } from '@angular/core';
import { ModalRef } from '../interfaces/modal-ref';

export const MODAL_REF = new InjectionToken<ModalRef>('MODAL_REF');
